import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  inject,
  input,
  viewChild,
} from "@angular/core";
import { CA_DATA } from "../../models/data.model";
import Chart from "chart.js/auto";
import { SharedModule } from "../../../../shared/shared.module";
import { WidgetHelperService } from "../../services/widget-helper.service";
import { Widget } from "../../models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { WidgetTitleComponent } from "../../../../shared/components/widget-title/widget-title.component";

@Component({
  selector: "vl-widget-ca-delta",
  standalone: true,
  imports: [SharedModule, WidgetTitleComponent],
  host: { class: "widget-component" },
  templateUrl: "./widget-ca-delta.component.html",
  styleUrl: "./widget-ca-delta.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetCaDeltaComponent {
  data = input<CA_DATA>();
  widget = input<Widget>();
  metadata = input<EntityMetadata>();
  filters: { timeScale: string; period: string };
  elementRef = inject(ElementRef);

  constructor() {
    effect(() => {
      if (this.data() && this.canvasRef()) {
        this.buildChart();
      }
    });
  }

  canvasRef = viewChild<ElementRef>("cadelta");

  chart: Chart;

  totalDisplay: string;

  buildChart() {
    if (this.data()?.data.length > 0) {
      let data = WidgetHelperService.getCaDeltaChart(
        this.data()?.data,
        this.filters,
      );
      const labels = [];
      const montants_negatifs = [];
      const montants_positifs = [];
      data = data.sort((a, b) => a.date.localeCompare(b.date));
      for (let i = 0; i < data.length; i++) {
        if (data[i].date && data[i].montant) {
          labels.push(data[i].date);
          if (data[i].montant < 0) {
            montants_negatifs.push(data[i].montant);
            montants_positifs.push(null);
          } else {
            montants_negatifs.push(null);
            montants_positifs.push(data[i].montant);
          }
        }
      }

      const bgAlt = getComputedStyle(
        this.elementRef.nativeElement,
      ).getPropertyValue("--color-on-background-alt");
      const accent = getComputedStyle(
        this.elementRef.nativeElement,
      ).getPropertyValue("--color-on-accent");
      const accentAlt = getComputedStyle(
        this.elementRef.nativeElement,
      ).getPropertyValue("--color-on-accent-alt");

      const datasetDeltaNegatifs = {
        label: "Delta tréso négatif",
        data: montants_negatifs,
        backgroundColor: accent,
      };

      const datasetDeltaPositifs = {
        label: "Delta tréso positif",
        data: montants_positifs,
        backgroundColor: accentAlt,
      };

      const canvas = this.canvasRef().nativeElement;
      const ctx = canvas.getContext("2d");

      // Supprimez le graphique précédent s'il en existe un
      if (this.chart) {
        this.chart.destroy();
      }

      // Créez un nouveau graphique
      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets: [datasetDeltaPositifs, datasetDeltaNegatifs],
          labels,
        },
        options: {
          plugins: {
            legend: {
              display: true,
              labels: {
                color: bgAlt,
              },
            },
          },
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            x: {
              stacked: true,
              ticks: {
                color: bgAlt,
              },
            },
            y: {
              stacked: true,
              ticks: {
                color: bgAlt,
              },
            },
          },
        },
      });
    }
  }
}
